import { z } from "zod";
import { isNonEmptyArray, type NonEmptyArray } from "../utils/types-helper.ts";

const keyListSchema = z.array(z.string()).min(1);

function base64Decode(input: string): string {
  if (typeof Buffer !== "undefined") {
    return Buffer.from(input, "base64").toString("utf-8");
  }
  return atob(input);
}

export function parseKeyList(base64String: string): NonEmptyArray<string> {
  const json = base64Decode(base64String);
  const parsed = keyListSchema.parse(JSON.parse(json));
  if (!isNonEmptyArray(parsed)) {
    throw new Error("Expected non-empty key list");
  }
  return parsed;
}
